import { supplementalExtraDefaultTranslations } from "./supplementalTranslations.js";
import { l10nAuditTranslations } from "./l10nAuditTranslations.js";

export const supportedLanguageCodes = ["en", "ar", "fr", "de", "ru"];

export const supportedLanguages = [
  { code: "en", name: "English", nativeName: "English", direction: "ltr", flag: "gb" },
  { code: "ar", name: "Arabic", nativeName: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629", direction: "rtl", flag: "ae" },
  { code: "fr", name: "French", nativeName: "Fran\u00e7ais", direction: "ltr", flag: "fr" },
  { code: "de", name: "German", nativeName: "Deutsch", direction: "ltr", flag: "de" },
  { code: "ru", name: "Russian", nativeName: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439", direction: "ltr", flag: "ru" },
];

export const languageLocaleMap = { en: "en_US", ar: "ar_AE", fr: "fr_FR", de: "de_DE", ru: "ru_RU" };

export const defaultTranslations = {
  "en": {
    "nav.home": "Home",
    "nav.cars": "Cars",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.faq": "FAQ",
    "nav.categories": "Categories",
    "nav.cities": "Cities",
    "nav.pricing": "Pricing",
    "nav.partners": "Partners",
    "nav.favorites": "Favorites",
    "nav.account": "Account",
    "nav.browseCars": "Browse Cars",
    "auth.createAccount": "Create Account",
    "auth.enterOTP": "Enter OTP",
    "auth.enterPhone": "Please enter your phone number",
    "auth.forgotPassword": "Forgot Password",
    "auth.loginError": "Login failed. Please try again.",
    "auth.loginSuccess": "Welcome back!",
    "auth.loginWithPhone": "Login with Phone",
    "auth.noAccount": "Don't have an account?",
    "auth.or": "or",
    "auth.otpError": "Invalid OTP. Please try again.",
    "auth.otpSent": "OTP sent to your phone",
    "auth.passwordMismatch": "Passwords do not match",
    "auth.phoneLogin": "Phone Login",
    "auth.registerError": "Registration failed. Please try again.",
    "auth.registerSuccess": "Account created successfully!",
    "auth.rememberMe": "Remember me",
    "auth.sendOTP": "Send OTP",
    "auth.signIn": "Sign In",
    "auth.signOut": "Sign Out",
    "auth.signUp": "Sign up",
    "auth.verify": "Verify & Login",
    "btn.back": "Back",
    "btn.bookNow": "Book Now",
    "btn.browse": "Browse Cars",
    "btn.browseAllCars": "Browse All Cars",
    "btn.call": "Call",
    "btn.callNow": "Call Now",
    "btn.chatWhatsApp": "Chat on WhatsApp",
    "btn.contactUs": "Contact Us",
    "btn.continue": "Continue",
    "btn.details": "Details",
    "btn.done": "Done",
    "btn.search": "Search",
    "btn.sendInquiry": "Send Inquiry",
    "btn.sendMessage": "Send Message",
    "btn.showLess": "Show Less",
    "btn.showMore": "Show More",
    "btn.submitInquiry": "Submit Inquiry",
    "btn.viewAll": "View All",
    "btn.viewAllCars": "View All Cars",
    "btn.viewAllFaqs": "View All FAQs",
    "btn.viewAllOffers": "View All Offers",
    "btn.viewExclusive": "View Exclusive",
    "btn.viewNewCars": "View New Cars",
    "btn.whatsapp": "WhatsApp",
    "common.address": "Address",
    "common.cancel": "Cancel",
    "common.carsAvailable": "cars available",
    "common.currency": "Currency",
    "common.darkMode": "Dark Mode",
    "common.day": "day",
    "common.email": "Email",
    "common.language": "Language",
    "common.lightMode": "Light Mode",
    "common.loading": "Loading...",
    "common.message": "Message",
    "common.monthly": "Monthly",
    "common.more": "More",
    "common.name": "Name",
    "common.noResults": "No results found",
    "common.perDay": "per day",
    "common.perMonth": "per month",
    "common.perWeek": "per week",
    "common.phone": "Phone",
    "common.search": "Search",
    "common.seats": "Seats",
    "common.settings": "Settings",
    "common.share": "Share",
    "common.theme": "Theme",
    "common.total": "Total",
    "common.vehicles": "vehicles",
    "common.vat": "VAT",
    "common.weekly": "Weekly",
    "common.workingHours": "Working Hours",
    "common.whatsapp": "WhatsApp",
    "contact.description": "Have questions? We're here to help. Reach out to us through any of the channels below.",
    "contact.followUs": "Follow Us",
    "contact.formDescription": "Fill out the form below and we'll get back to you as soon as possible.",
    "contact.getApp": "Get Our App",
    "contact.info": "Contact Information",
    "contact.instantResponse": "Get instant response via WhatsApp",
    "contact.messageSent": "Message sent successfully! We'll get back to you soon.",
    "contact.pageTitle": "Contact Us | Get in Touch for Car Rental",
    "contact.quickContact": "Quick Contact",
    "contact.sendMessage": "Send us a Message",
    "contact.subtitle": "Get in Touch",
    "cta.title": "Ready to Experience Luxury?",
    "favorites.emptySubtitle": "Save your favorite cars here",
    "favorites.emptyTitle": "No Favorites Yet",
    "favorites.loading": "Loading favorites...",
    "favorites.title": "Favorites",
    "faq.category.all": "All",
    "faq.category.booking": "Booking",
    "faq.category.documents": "Documents",
    "faq.category.general": "General",
    "faq.category.insurance": "Insurance",
    "faq.category.payment": "Payment",
    "faq.clearFilters": "Clear filters",
    "faq.heading": "Frequently Asked Questions",
    "faq.noQuestions": "No questions found.",
    "faq.searchPlaceholder": "Search for answers...",
    "faq.title": "FAQ",
    "filter.brand": "Brand",
    "filter.category": "Category",
    "filter.city": "City",
    "filter.clearAll": "Clear All Filters",
    "filter.color": "Color",
    "filter.priceRange": "Price Range",
    "filter.search": "Search",
    "filter.searchPlaceholder": "Search cars...",
    "filter.seats": "Number of Seats",
    "filter.title": "Filters",
    "footer.brands": "Top Brands",
    "footer.callUs": "Call Us",
    "footer.categories": "Categories",
    "footer.cities": "Locations",
    "footer.downloadApp": "Download App",
    "footer.emailUs": "Email Us",
    "footer.quickLinks": "Quick Links",
    "footer.privacyPolicy": "Privacy Policy",
    "footer.visitUs": "Visit Our Office",
    "footer.visitors": "visitors",
    "footer.weAccept": "We Accept",
    "form.email": "Email Address",
    "form.fullName": "Full Name",
    "form.message": "Message",
    "form.name": "Name",
    "form.password": "Password",
    "form.phone": "Phone Number",
    "home.experienceLuxury": "Experience Luxury On Every Journey",
    "home.featuredVehicles": "Featured Vehicles",
    "home.premiumCarRental": "Premium Car Rental UAE",
    "inquiry.error": "Failed to send inquiry. Please try again.",
    "inquiry.success": "Inquiry sent successfully! We'll contact you soon.",
    "inquiry.title": "Send Us a Message",
    "listings.noResults": "No vehicles match your filters.",
    "listings.noResultsHint": "Try clearing a few filters and search again.",
    "listings.pageTitle": "Rent Cars in UAE | Browse Luxury, Sports & Economy Cars",
    "listings.showing": "Showing",
    "listings.subtitle": "Discover the perfect vehicle for your journey from our extensive fleet",
    "listings.title": "Browse Our",
    "listings.titleHighlight": "Collection",
    "listings.vehicles": "vehicles",
    "messages.featuredComingSoon": "Featured vehicles coming soon",
    "notifications.comingSoon": "Notifications coming soon",
    "partners.all": "All",
    "partners.allPartners": "All Partners",
    "partners.becomePartner": "Become a Partner",
    "partners.contactUs": "Contact Us",
    "partners.description": "We collaborate with the finest automotive partners to deliver an unparalleled luxury car rental experience.",
    "partners.featuredPartners": "Featured Partners",
    "partners.featuredTitle": "Premium Collaborations",
    "partners.learnMore": "Learn more",
    "partners.ourNetwork": "Our Network",
    "partners.pageTitle": "Our Partners",
    "partners.subtitle": "Trusted Network",
    "partners.title": "Our Partners",
    "partners.visitWebsite": "Visit Website",
    "pricing.allBrands": "All Brands",
    "pricing.brandAZ": "Brand: A-Z",
    "pricing.brandZA": "Brand: Z-A",
    "pricing.carsFound": "cars found",
    "pricing.category": "Category",
    "pricing.daily": "Daily",
    "pricing.description": "Compare prices across our entire fleet.",
    "pricing.monthly": "Monthly",
    "pricing.noResults": "No cars found matching your criteria.",
    "pricing.pageTitle": "Car Rental Pricing",
    "pricing.priceHighest": "Price: Highest First",
    "pricing.priceLowest": "Price: Lowest First",
    "pricing.resetFilters": "Reset Filters",
    "pricing.sortBy": "Sort By",
    "pricing.subtitle": "Transparent Pricing",
    "pricing.title": "Car Rental Pricing",
    "pricing.vehicle": "Vehicle",
    "pricing.weekly": "Weekly",
    "profile.aboutUs": "About Us",
    "profile.contactUs": "Contact Us",
    "profile.faq": "FAQ",
    "profile.guestUser": "Guest User",
    "profile.loyaltyRewards": "Loyalty Rewards",
    "profile.myBookings": "My Bookings",
    "profile.rateApp": "Rate App",
    "profile.shareApp": "Share App",
    "search.allCategories": "All Categories",
    "search.brand": "Brand",
    "search.brands": "Brands",
    "search.category": "Category",
    "search.city": "City",
    "search.placeholder": "Select...",
    "search.popular": "Popular",
    "search.recommended": "Recommended",
    "search.selectBrand": "Select Brand",
    "search.selectCity": "Select City",
    "sections.availableLocations": "Available Locations",
    "sections.brands": "Explore by Brand",
    "sections.browseByType": "Browse by Type",
    "sections.categories": "Explore Our Categories",
    "sections.cities": "Rent Cars in UAE Cities",
    "sections.exclusiveDeals": "Exclusive Deals",
    "sections.faq": "FAQ",
    "sections.faqTitle": "Frequently Asked Questions",
    "sections.featured": "Featured Vehicles",
    "sections.handPicked": "Hand-picked Selection",
    "sections.justArrived": "Just Arrived",
    "sections.latestOffers": "Latest Offers",
    "sections.limitedTime": "Limited Time",
    "sections.newCars": "New Cars",
    "sections.premiumPartners": "Premium Partners",
    "sections.premiumSelection": "Premium Selection",
    "sections.testimonials": "Testimonials",
    "sections.velarisDifference": "The Velaris Difference",
    "sections.whatClientsSay": "What Our Clients Say",
    "sections.whyChooseUs": "Why Choose Us",
    "sort.featured": "Featured",
    "sort.highestRated": "Highest Rated",
    "sort.nameAZ": "Name: A-Z",
    "sort.nameZA": "Name: Z-A",
    "sort.newest": "Newest",
    "sort.placeholder": "Sort by",
    "sort.priceHigh": "Price: High to Low",
    "sort.priceLow": "Price: Low to High",
    "splash.loading": "Preparing your luxury experience...",
    "splash.tagline": "Experience Luxury"
  },
  "ar": {
    "nav.home": "\u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629",
    "nav.cars": "\u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "nav.about": "\u0645\u0646 \u0646\u062d\u0646",
    "nav.contact": "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    "nav.faq": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
    "nav.categories": "\u0627\u0644\u0641\u0626\u0627\u062a",
    "nav.cities": "\u0627\u0644\u0645\u062f\u0646",
    "nav.pricing": "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
    "nav.partners": "\u0627\u0644\u0634\u0631\u0643\u0627\u0621",
    "nav.favorites": "\u0627\u0644\u0645\u0641\u0636\u0644\u0629",
    "nav.account": "\u0627\u0644\u062d\u0633\u0627\u0628",
    "nav.browseCars": "\u062a\u0635\u0641\u062d \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "auth.createAccount": "\u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628",
    "auth.enterOTP": "\u0623\u062f\u062e\u0644 \u0631\u0645\u0632 \u0627\u0644\u062a\u062d\u0642\u0642",
    "auth.enterPhone": "\u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",
    "auth.forgotPassword": "\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "auth.loginError": "\u0641\u0634\u0644 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644. \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
    "auth.loginSuccess": "\u0645\u0631\u062d\u0628\u064b\u0627 \u0628\u0639\u0648\u062f\u062a\u0643!",
    "auth.loginWithPhone": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0628\u0627\u0644\u0647\u0627\u062a\u0641",
    "auth.noAccount": "\u0644\u064a\u0633 \u0644\u062f\u064a\u0643 \u062d\u0633\u0627\u0628\u061f",
    "auth.or": "\u0623\u0648",
    "auth.otpError": "\u0631\u0645\u0632 \u0627\u0644\u062a\u062d\u0642\u0642 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d. \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
    "auth.otpSent": "\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062a\u062d\u0642\u0642 \u0625\u0644\u0649 \u0647\u0627\u062a\u0641\u0643",
    "auth.passwordMismatch": "\u0643\u0644\u0645\u062a\u0627 \u0627\u0644\u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0645\u062a\u0637\u0627\u0628\u0642\u062a\u064a\u0646",
    "auth.phoneLogin": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0628\u0627\u0644\u0647\u0627\u062a\u0641",
    "auth.registerError": "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062d\u0633\u0627\u0628. \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
    "auth.registerSuccess": "\u062a\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062d\u0633\u0627\u0628 \u0628\u0646\u062c\u0627\u062d!",
    "auth.rememberMe": "\u062a\u0630\u0643\u0631\u0646\u064a",
    "auth.sendOTP": "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
    "auth.signIn": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    "auth.signOut": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c",
    "auth.signUp": "\u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628",
    "auth.verify": "\u062a\u062d\u0642\u0642 \u0648\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    "btn.back": "\u0631\u062c\u0648\u0639",
    "btn.bookNow": "\u0627\u062d\u062c\u0632 \u0627\u0644\u0622\u0646",
    "btn.browse": "\u062a\u0635\u0641\u062d \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "btn.browseAllCars": "\u062a\u0635\u0641\u062d \u062c\u0645\u064a\u0639 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "btn.call": "\u0627\u062a\u0635\u0627\u0644",
    "btn.callNow": "\u0627\u062a\u0635\u0644 \u0627\u0644\u0622\u0646",
    "btn.chatWhatsApp": "\u062a\u0648\u0627\u0635\u0644 \u0639\u0628\u0631 \u0648\u0627\u062a\u0633\u0627\u0628",
    "btn.contactUs": "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    "btn.continue": "\u0645\u062a\u0627\u0628\u0639\u0629",
    "btn.details": "\u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644",
    "btn.done": "\u062a\u0645",
    "btn.search": "\u0628\u062d\u062b",
    "btn.sendInquiry": "\u0625\u0631\u0633\u0627\u0644 \u0627\u0633\u062a\u0641\u0633\u0627\u0631",
    "btn.sendMessage": "\u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629",
    "btn.showLess": "\u0639\u0631\u0636 \u0623\u0642\u0644",
    "btn.showMore": "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064a\u062f",
    "btn.submitInquiry": "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0633\u062a\u0641\u0633\u0627\u0631",
    "btn.viewAll": "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
    "btn.viewAllCars": "\u0639\u0631\u0636 \u062c\u0645\u064a\u0639 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "btn.viewAllFaqs": "\u0639\u0631\u0636 \u062c\u0645\u064a\u0639 \u0627\u0644\u0623\u0633\u0626\u0644\u0629",
    "btn.viewAllOffers": "\u0639\u0631\u0636 \u062c\u0645\u064a\u0639 \u0627\u0644\u0639\u0631\u0648\u0636",
    "btn.viewExclusive": "\u0639\u0631\u0636 \u0627\u0644\u062d\u0635\u0631\u064a",
    "btn.viewNewCars": "\u0639\u0631\u0636 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a \u0627\u0644\u062c\u062f\u064a\u062f\u0629",
    "btn.whatsapp": "\u0648\u0627\u062a\u0633\u0627\u0628",
    "common.address": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    "common.cancel": "\u0625\u0644\u063a\u0627\u0621",
    "common.carsAvailable": "\u0633\u064a\u0627\u0631\u0627\u062a \u0645\u062a\u0627\u062d\u0629",
    "common.currency": "\u0627\u0644\u0639\u0645\u0644\u0629",
    "common.darkMode": "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062f\u0627\u0643\u0646",
    "common.day": "\u064a\u0648\u0645",
    "common.email": "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "common.language": "\u0627\u0644\u0644\u063a\u0629",
    "common.lightMode": "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062a\u062d",
    "common.loading": "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",
    "common.message": "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    "common.monthly": "\u0634\u0647\u0631\u064a",
    "common.more": "\u0627\u0644\u0645\u0632\u064a\u062f",
    "common.name": "\u0627\u0644\u0627\u0633\u0645",
    "common.noResults": "\u0644\u0627 \u062a\u0648\u062c\u062f \u0646\u062a\u0627\u0626\u062c",
    "common.perDay": "\u0641\u064a \u0627\u0644\u064a\u0648\u0645",
    "common.perMonth": "\u0641\u064a \u0627\u0644\u0634\u0647\u0631",
    "common.perWeek": "\u0641\u064a \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
    "common.phone": "\u0627\u0644\u0647\u0627\u062a\u0641",
    "common.search": "\u0628\u062d\u062b",
    "common.seats": "\u0627\u0644\u0645\u0642\u0627\u0639\u062f",
    "common.settings": "\u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a",
    "common.share": "\u0645\u0634\u0627\u0631\u0643\u0629",
    "common.theme": "\u0627\u0644\u0633\u0645\u0629",
    "common.total": "\u0627\u0644\u0625\u062c\u0645\u0627\u0644\u064a",
    "common.vehicles": "\u0645\u0631\u0643\u0628\u0627\u062a",
    "common.vat": "\u0636\u0631\u064a\u0628\u0629 \u0627\u0644\u0642\u064a\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    "common.weekly": "\u0623\u0633\u0628\u0648\u0639\u064a",
    "common.workingHours": "\u0633\u0627\u0639\u0627\u062a \u0627\u0644\u0639\u0645\u0644",
    "common.whatsapp": "\u0648\u0627\u062a\u0633\u0627\u0628",
    "contact.description": "\u0647\u0644 \u0644\u062f\u064a\u0643 \u0623\u0633\u0626\u0644\u0629\u061f \u0646\u062d\u0646 \u0647\u0646\u0627 \u0644\u0644\u0645\u0633\u0627\u0639\u062f\u0629.",
    "contact.followUs": "\u062a\u0627\u0628\u0639\u0646\u0627",
    "contact.formDescription": "\u0627\u0645\u0644\u0623 \u0627\u0644\u0646\u0645\u0648\u0630\u062c \u0623\u062f\u0646\u0627\u0647 \u0648\u0633\u0646\u0639\u0627\u0648\u062f \u0627\u0644\u062a\u0648\u0627\u0635\u0644 \u0645\u0639\u0643 \u0641\u064a \u0623\u0642\u0631\u0628 \u0648\u0642\u062a \u0645\u0645\u0643\u0646.",
    "contact.getApp": "\u062d\u0645\u0651\u0644 \u062a\u0637\u0628\u064a\u0642\u0646\u0627",
    "contact.info": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0648\u0627\u0635\u0644",
    "contact.instantResponse": "\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0631\u062f \u0641\u0648\u0631\u064a \u0639\u0628\u0631 \u0648\u0627\u062a\u0633\u0627\u0628",
    "contact.messageSent": "\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u062a\u0643 \u0628\u0646\u062c\u0627\u062d!",
    "contact.pageTitle": "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627 | \u062a\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627 \u0644\u062a\u0623\u062c\u064a\u0631 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "contact.quickContact": "\u062a\u0648\u0627\u0635\u0644 \u0633\u0631\u064a\u0639",
    "contact.sendMessage": "\u0623\u0631\u0633\u0644 \u0644\u0646\u0627 \u0631\u0633\u0627\u0644\u0629",
    "contact.subtitle": "\u0627\u0628\u0642\u064e \u0639\u0644\u0649 \u062a\u0648\u0627\u0635\u0644",
    "cta.title": "\u0647\u0644 \u0623\u0646\u062a \u0645\u0633\u062a\u0639\u062f \u0644\u062a\u062c\u0631\u0628\u0629 \u0627\u0644\u0641\u062e\u0627\u0645\u0629\u061f",
    "favorites.emptySubtitle": "\u0627\u062d\u0641\u0638 \u0633\u064a\u0627\u0631\u0627\u062a\u0643 \u0627\u0644\u0645\u0641\u0636\u0644\u0629 \u0647\u0646\u0627",
    "favorites.emptyTitle": "\u0644\u0627 \u062a\u0648\u062c\u062f \u0645\u0641\u0636\u0644\u0627\u062a \u0628\u0639\u062f",
    "favorites.loading": "\u062c\u0627\u0631\u064a \u062a\u062d\u0645\u064a\u0644 \u0627\u0644\u0645\u0641\u0636\u0644\u0627\u062a...",
    "favorites.title": "\u0627\u0644\u0645\u0641\u0636\u0644\u0629",
    "faq.category.all": "\u0627\u0644\u0643\u0644",
    "faq.category.booking": "\u0627\u0644\u062d\u062c\u0632",
    "faq.category.documents": "\u0627\u0644\u0645\u0633\u062a\u0646\u062f\u0627\u062a",
    "faq.category.general": "\u0639\u0627\u0645",
    "faq.category.insurance": "\u0627\u0644\u062a\u0623\u0645\u064a\u0646",
    "faq.category.payment": "\u0627\u0644\u062f\u0641\u0639",
    "faq.clearFilters": "\u0645\u0633\u062d \u0627\u0644\u0641\u0644\u0627\u062a\u0631",
    "faq.heading": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
    "faq.noQuestions": "\u0644\u0645 \u064a\u062a\u0645 \u0627\u0644\u0639\u062b\u0648\u0631 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u0629.",
    "faq.searchPlaceholder": "\u0627\u0628\u062d\u062b \u0639\u0646 \u0627\u0644\u0625\u062c\u0627\u0628\u0627\u062a...",
    "faq.title": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
    "filter.brand": "\u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062a\u062c\u0627\u0631\u064a\u0629",
    "filter.category": "\u0627\u0644\u0641\u0626\u0629",
    "filter.city": "\u0627\u0644\u0645\u062f\u064a\u0646\u0629",
    "filter.clearAll": "\u0645\u0633\u062d \u062c\u0645\u064a\u0639 \u0627\u0644\u0641\u0644\u0627\u062a\u0631",
    "filter.color": "\u0627\u0644\u0644\u0648\u0646",
    "filter.priceRange": "\u0646\u0637\u0627\u0642 \u0627\u0644\u0633\u0639\u0631",
    "filter.search": "\u0628\u062d\u062b",
    "filter.searchPlaceholder": "\u0627\u0628\u062d\u062b \u0639\u0646 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a...",
    "filter.seats": "\u0639\u062f\u062f \u0627\u0644\u0645\u0642\u0627\u0639\u062f",
    "filter.title": "\u0627\u0644\u0641\u0644\u0627\u062a\u0631",
    "footer.brands": "\u0623\u0641\u0636\u0644 \u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062a",
    "footer.callUs": "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    "footer.categories": "\u0627\u0644\u0641\u0626\u0627\u062a",
    "footer.cities": "\u0627\u0644\u0645\u0648\u0627\u0642\u0639",
    "footer.downloadApp": "\u062d\u0645\u0651\u0644 \u0627\u0644\u062a\u0637\u0628\u064a\u0642",
    "footer.emailUs": "\u0631\u0627\u0633\u0644\u0646\u0627",
    "footer.quickLinks": "\u0631\u0648\u0627\u0628\u0637 \u0633\u0631\u064a\u0639\u0629",
    "footer.privacyPolicy": "\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629",
    "footer.visitUs": "\u0632\u0631 \u0645\u0643\u062a\u0628\u0646\u0627",
    "footer.visitors": "\u0632\u0627\u0626\u0631",
    "footer.weAccept": "\u0646\u0642\u0628\u0644",
    "form.email": "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "form.fullName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
    "form.message": "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    "form.name": "\u0627\u0644\u0627\u0633\u0645",
    "form.password": "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "form.phone": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",
    "home.experienceLuxury": "\u0627\u0633\u062a\u0645\u062a\u0639 \u0628\u0627\u0644\u0641\u062e\u0627\u0645\u0629 \u0641\u064a \u0643\u0644 \u0631\u062d\u0644\u0629",
    "home.featuredVehicles": "\u0627\u0644\u0645\u0631\u0643\u0628\u0627\u062a \u0627\u0644\u0645\u0645\u064a\u0632\u0629",
    "home.premiumCarRental": "\u062a\u0623\u062c\u064a\u0631 \u0633\u064a\u0627\u0631\u0627\u062a \u0641\u0627\u062e\u0631\u0629 \u0641\u064a \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062a",
    "inquiry.error": "\u0641\u0634\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0633\u062a\u0641\u0633\u0627\u0631. \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
    "inquiry.success": "\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0633\u062a\u0641\u0633\u0627\u0631 \u0628\u0646\u062c\u0627\u062d! \u0633\u0646\u062a\u0648\u0627\u0635\u0644 \u0645\u0639\u0643 \u0642\u0631\u064a\u0628\u064b\u0627.",
    "inquiry.title": "\u0623\u0631\u0633\u0644 \u0644\u0646\u0627 \u0631\u0633\u0627\u0644\u0629",
    "listings.noResults": "\u0644\u0627 \u062a\u0648\u062c\u062f \u0633\u064a\u0627\u0631\u0627\u062a \u0645\u0637\u0627\u0628\u0642\u0629 \u0644\u0644\u0641\u0644\u0627\u062a\u0631.",
    "listings.noResultsHint": "\u062c\u0631\u0651\u0628 \u0645\u0633\u062d \u0628\u0639\u0636 \u0627\u0644\u0641\u0644\u0627\u062a\u0631 \u062b\u0645 \u0627\u0628\u062d\u062b \u0645\u062c\u062f\u062f\u064b\u0627.",
    "listings.pageTitle": "\u0627\u0633\u062a\u0623\u062c\u0631 \u0633\u064a\u0627\u0631\u0627\u062a \u0641\u064a \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062a",
    "listings.showing": "\u0639\u0631\u0636",
    "listings.subtitle": "\u0627\u0643\u062a\u0634\u0641 \u0627\u0644\u0633\u064a\u0627\u0631\u0629 \u0627\u0644\u0645\u062b\u0627\u0644\u064a\u0629 \u0644\u0631\u062d\u0644\u062a\u0643",
    "listings.title": "\u062a\u0635\u0641\u062d",
    "listings.titleHighlight": "\u0645\u062c\u0645\u0648\u0639\u062a\u0646\u0627",
    "listings.vehicles": "\u0633\u064a\u0627\u0631\u0629",
    "messages.featuredComingSoon": "\u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a \u0627\u0644\u0645\u0645\u064a\u0632\u0629 \u0633\u062a\u062a\u0648\u0641\u0631 \u0642\u0631\u064a\u0628\u064b\u0627",
    "notifications.comingSoon": "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062a \u0633\u062a\u062a\u0648\u0641\u0631 \u0642\u0631\u064a\u0628\u064b\u0627",
    "partners.all": "\u0627\u0644\u0643\u0644",
    "partners.allPartners": "\u062c\u0645\u064a\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
    "partners.becomePartner": "\u0643\u0646 \u0634\u0631\u064a\u0643\u064b\u0627",
    "partners.contactUs": "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    "partners.description": "\u0646\u062a\u0639\u0627\u0648\u0646 \u0645\u0639 \u0623\u0641\u0636\u0644 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0641\u064a \u0642\u0637\u0627\u0639 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a \u0644\u0646\u0642\u062f\u0645 \u062a\u062c\u0631\u0628\u0629 \u062a\u0623\u062c\u064a\u0631 \u0641\u0627\u062e\u0631\u0629 \u0644\u0627 \u0645\u062b\u064a\u0644 \u0644\u0647\u0627.",
    "partners.featuredPartners": "\u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0627\u0644\u0645\u0645\u064a\u0632\u0648\u0646",
    "partners.featuredTitle": "\u062a\u0639\u0627\u0648\u0646\u0627\u062a \u0645\u0645\u064a\u0632\u0629",
    "partners.learnMore": "\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064a\u062f",
    "partners.ourNetwork": "\u0634\u0628\u0643\u062a\u0646\u0627",
    "partners.pageTitle": "\u0634\u0631\u0643\u0627\u0624\u0646\u0627",
    "partners.subtitle": "\u0634\u0628\u0643\u0629 \u0645\u0648\u062b\u0648\u0642\u0629",
    "partners.title": "\u0634\u0631\u0643\u0627\u0624\u0646\u0627",
    "partners.visitWebsite": "\u0632\u064a\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0642\u0639",
    "pricing.allBrands": "\u062c\u0645\u064a\u0639 \u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062a",
    "pricing.brandAZ": "\u0627\u0644\u0639\u0644\u0627\u0645\u0629: \u0623-\u064a",
    "pricing.brandZA": "\u0627\u0644\u0639\u0644\u0627\u0645\u0629: \u064a-\u0623",
    "pricing.carsFound": "\u0633\u064a\u0627\u0631\u0629",
    "pricing.category": "\u0627\u0644\u0641\u0626\u0629",
    "pricing.daily": "\u064a\u0648\u0645\u064a",
    "pricing.description": "\u0642\u0627\u0631\u0646 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0639\u0628\u0631 \u0623\u0633\u0637\u0648\u0644\u0646\u0627 \u0628\u0627\u0644\u0643\u0627\u0645\u0644.",
    "pricing.monthly": "\u0634\u0647\u0631\u064a",
    "pricing.noResults": "\u0644\u0645 \u064a\u062a\u0645 \u0627\u0644\u0639\u062b\u0648\u0631 \u0639\u0644\u0649 \u0633\u064a\u0627\u0631\u0627\u062a \u0645\u0637\u0627\u0628\u0642\u0629.",
    "pricing.pageTitle": "\u0623\u0633\u0639\u0627\u0631 \u062a\u0623\u062c\u064a\u0631 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "pricing.priceHighest": "\u0627\u0644\u0633\u0639\u0631: \u0645\u0646 \u0627\u0644\u0623\u0639\u0644\u0649 \u0644\u0644\u0623\u0642\u0644",
    "pricing.priceLowest": "\u0627\u0644\u0633\u0639\u0631: \u0645\u0646 \u0627\u0644\u0623\u0642\u0644 \u0644\u0644\u0623\u0639\u0644\u0649",
    "pricing.resetFilters": "\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0627\u0644\u0641\u0644\u0627\u062a\u0631",
    "pricing.sortBy": "\u062a\u0631\u062a\u064a\u0628 \u062d\u0633\u0628",
    "pricing.subtitle": "\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0636\u062d\u0629",
    "pricing.title": "\u0623\u0633\u0639\u0627\u0631 \u062a\u0623\u062c\u064a\u0631 \u0627\u0644\u0633\u064a\u0627\u0631\u0627\u062a",
    "pricing.vehicle": "\u0627\u0644\u0645\u0631\u0643\u0628\u0629",
    "pricing.weekly": "\u0623\u0633\u0628\u0648\u0639\u064a",
    "profile.aboutUs": "\u0645\u0646 \u0646\u062d\u0646",
    "profile.contactUs": "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    "profile.faq": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
    "profile.guestUser": "\u0645\u0633\u062a\u062e\u062f\u0645 \u0632\u0627\u0626\u0631",
    "profile.loyaltyRewards": "\u0645\u0643\u0627\u0641\u0622\u062a \u0627\u0644\u0648\u0644\u0627\u0621",
    "profile.myBookings": "\u062d\u062c\u0648\u0632\u0627\u062a\u064a",
    "profile.rateApp": "\u0642\u064a\u0651\u0645 \u0627\u0644\u062a\u0637\u0628\u064a\u0642",
    "profile.shareApp": "\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u062a\u0637\u0628\u064a\u0642",
    "search.allCategories": "\u062c\u0645\u064a\u0639 \u0627\u0644\u0641\u0626\u0627\u062a",
    "search.brand": "\u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062a\u062c\u0627\u0631\u064a\u0629",
    "search.brands": "\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062a \u0627\u0644\u062a\u062c\u0627\u0631\u064a\u0629",
    "search.category": "\u0627\u0644\u0641\u0626\u0629",
    "search.city": "\u0627\u0644\u0645\u062f\u064a\u0646\u0629",
    "search.placeholder": "\u0627\u062e\u062a\u0631...",
    "search.popular": "\u0627\u0644\u0623\u0643\u062b\u0631 \u0634\u064a\u0648\u0639\u064b\u0627",
    "search.recommended": "\u0645\u0648\u0635\u0649 \u0628\u0647",
    "search.selectBrand": "\u0627\u062e\u062a\u0631 \u0627\u0644\u0639\u0644\u0627\u0645\u0629",
    "search.selectCity": "\u0627\u062e\u062a\u0631 \u0627\u0644\u0645\u062f\u064a\u0646\u0629",
    "sections.availableLocations": "\u0627\u0644\u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0645\u062a\u0627\u062d\u0629",
    "sections.brands": "\u0627\u0633\u062a\u0643\u0634\u0641 \u062d\u0633\u0628 \u0627\u0644\u0639\u0644\u0627\u0645\u0629",
    "sections.browseByType": "\u062a\u0635\u0641\u062d \u062d\u0633\u0628 \u0627\u0644\u0646\u0648\u0639",
    "sections.categories": "\u0627\u0633\u062a\u0643\u0634\u0641 \u0641\u0626\u0627\u062a\u0646\u0627",
    "sections.cities": "\u0627\u0633\u062a\u0623\u062c\u0631 \u0633\u064a\u0627\u0631\u0627\u062a \u0641\u064a \u0645\u062f\u0646 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062a",
    "sections.exclusiveDeals": "\u0639\u0631\u0648\u0636 \u062d\u0635\u0631\u064a\u0629",
    "sections.faq": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
    "sections.faqTitle": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
    "sections.featured": "\u0627\u0644\u0645\u0631\u0643\u0628\u0627\u062a \u0627\u0644\u0645\u0645\u064a\u0632\u0629",
    "sections.handPicked": "\u0627\u062e\u062a\u064a\u0627\u0631 \u0628\u0639\u0646\u0627\u064a\u0629",
    "sections.justArrived": "\u0648\u0635\u0644\u062a \u062d\u062f\u064a\u062b\u064b\u0627",
    "sections.latestOffers": "\u0623\u062d\u062f\u062b \u0627\u0644\u0639\u0631\u0648\u0636",
    "sections.limitedTime": "\u0644\u0641\u062a\u0631\u0629 \u0645\u062d\u062f\u0648\u062f\u0629",
    "sections.newCars": "\u0633\u064a\u0627\u0631\u0627\u062a \u062c\u062f\u064a\u062f\u0629",
    "sections.premiumPartners": "\u0634\u0631\u0643\u0627\u0621 \u0645\u0645\u064a\u0632\u0648\u0646",
    "sections.premiumSelection": "\u0627\u062e\u062a\u064a\u0627\u0631\u0627\u062a \u0645\u0645\u064a\u0632\u0629",
    "sections.testimonials": "\u0622\u0631\u0627\u0621 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
    "sections.velarisDifference": "\u062a\u0645\u064a\u0651\u0632 \u0641\u064a\u0644\u0627\u0631\u064a\u0633",
    "sections.whatClientsSay": "\u0645\u0627\u0630\u0627 \u064a\u0642\u0648\u0644 \u0639\u0645\u0644\u0627\u0624\u0646\u0627",
    "sections.whyChooseUs": "\u0644\u0645\u0627\u0630\u0627 \u0646\u062d\u0646",
    "sort.featured": "\u0645\u0645\u064a\u0632\u0629",
    "sort.highestRated": "\u0627\u0644\u0623\u0639\u0644\u0649 \u062a\u0642\u064a\u064a\u0645\u064b\u0627",
    "sort.nameAZ": "\u0627\u0644\u0627\u0633\u0645: \u0623-\u064a",
    "sort.nameZA": "\u0627\u0644\u0627\u0633\u0645: \u064a-\u0623",
    "sort.newest": "\u0627\u0644\u0623\u062d\u062f\u062b",
    "sort.placeholder": "\u062a\u0631\u062a\u064a\u0628 \u062d\u0633\u0628",
    "sort.priceHigh": "\u0627\u0644\u0633\u0639\u0631: \u0645\u0646 \u0627\u0644\u0623\u0639\u0644\u0649 \u0644\u0644\u0623\u0642\u0644",
    "sort.priceLow": "\u0627\u0644\u0633\u0639\u0631: \u0645\u0646 \u0627\u0644\u0623\u0642\u0644 \u0644\u0644\u0623\u0639\u0644\u0649",
    "splash.loading": "\u0646\u062c\u0647\u0632 \u0644\u0643 \u062a\u062c\u0631\u0628\u0629 \u0641\u0627\u062e\u0631\u0629...",
    "splash.tagline": "\u0627\u0633\u062a\u0645\u062a\u0639 \u0628\u0627\u0644\u0641\u062e\u0627\u0645\u0629"
  },
  "fr": {
    "nav.home": "Accueil",
    "nav.cars": "Voitures",
    "nav.about": "\u00c0 propos",
    "nav.contact": "Contact",
    "nav.faq": "FAQ",
    "nav.categories": "Cat\u00e9gories",
    "nav.cities": "Villes",
    "nav.pricing": "Tarifs",
    "nav.partners": "Partenaires",
    "nav.favorites": "Favoris",
    "nav.account": "Compte",
    "nav.browseCars": "Voir les voitures",
    "auth.createAccount": "Cr\u00e9er un compte",
    "auth.enterOTP": "Saisir le code OTP",
    "auth.enterPhone": "Veuillez saisir votre num\u00e9ro",
    "auth.forgotPassword": "Mot de passe oubli\u00e9",
    "auth.loginError": "\u00c9chec de la connexion. R\u00e9essayez.",
    "auth.loginSuccess": "Bon retour !",
    "auth.loginWithPhone": "Connexion par t\u00e9l\u00e9phone",
    "auth.noAccount": "Vous n'avez pas de compte ?",
    "auth.or": "ou",
    "auth.otpError": "Code OTP invalide. R\u00e9essayez.",
    "auth.otpSent": "Le code OTP a \u00e9t\u00e9 envoy\u00e9",
    "auth.passwordMismatch": "Les mots de passe ne correspondent pas",
    "auth.phoneLogin": "Connexion t\u00e9l\u00e9phone",
    "auth.registerError": "\u00c9chec de l'inscription. R\u00e9essayez.",
    "auth.registerSuccess": "Compte cr\u00e9\u00e9 avec succ\u00e8s !",
    "auth.rememberMe": "Se souvenir de moi",
    "auth.sendOTP": "Envoyer le code",
    "auth.signIn": "Se connecter",
    "auth.signOut": "Se d\u00e9connecter",
    "auth.signUp": "S'inscrire",
    "auth.verify": "V\u00e9rifier et se connecter",
    "btn.bookNow": "R\u00e9server",
    "btn.browse": "Voir les voitures",
    "btn.callNow": "Appeler maintenant",
    "btn.contactUs": "Nous contacter",
    "btn.search": "Rechercher",
    "btn.viewAll": "Voir tout",
    "common.address": "Adresse",
    "common.cancel": "Annuler",
    "common.carsAvailable": "voitures disponibles",
    "common.currency": "Devise",
    "common.darkMode": "Mode sombre",
    "common.day": "jour",
    "common.email": "E-mail",
    "common.language": "Langue",
    "common.lightMode": "Mode clair",
    "common.loading": "Chargement...",
    "common.message": "Message",
    "common.monthly": "Mensuel",
    "common.more": "Plus",
    "common.name": "Nom",
    "common.noResults": "Aucun r\u00e9sultat",
    "common.perDay": "par jour",
    "common.perMonth": "par mois",
    "common.perWeek": "par semaine",
    "common.phone": "T\u00e9l\u00e9phone",
    "common.search": "Rechercher",
    "common.seats": "Places",
    "common.settings": "Param\u00e8tres",
    "common.share": "Partager",
    "common.theme": "Th\u00e8me",
    "common.total": "Total",
    "common.vehicles": "v\u00e9hicules",
    "common.vat": "TVA",
    "common.weekly": "Hebdomadaire",
    "common.workingHours": "Horaires",
    "contact.description": "Des questions ? Nous sommes l\u00e0 pour vous aider.",
    "contact.followUs": "Suivez-nous",
    "contact.formDescription": "Remplissez le formulaire ci-dessous et nous vous r\u00e9pondrons rapidement.",
    "contact.getApp": "T\u00e9l\u00e9charger l'application",
    "contact.info": "Informations de contact",
    "contact.instantResponse": "R\u00e9ponse instantan\u00e9e via WhatsApp",
    "contact.messageSent": "Message envoy\u00e9 avec succ\u00e8s !",
    "contact.pageTitle": "Contactez-nous | Location de voiture",
    "contact.quickContact": "Contact rapide",
    "contact.sendMessage": "Envoyez-nous un message",
    "contact.subtitle": "Prenez contact",
    "favorites.emptySubtitle": "Enregistrez ici vos voitures pr\u00e9f\u00e9r\u00e9es",
    "favorites.emptyTitle": "Aucun favori pour le moment",
    "favorites.loading": "Chargement des favoris...",
    "favorites.title": "Favoris",
    "faq.heading": "Questions fr\u00e9quentes",
    "faq.noQuestions": "Aucune question trouv\u00e9e.",
    "faq.searchPlaceholder": "Rechercher une r\u00e9ponse...",
    "faq.title": "FAQ",
    "filter.brand": "Marque",
    "filter.category": "Cat\u00e9gorie",
    "filter.city": "Ville",
    "filter.clearAll": "Effacer tous les filtres",
    "filter.color": "Couleur",
    "filter.priceRange": "Fourchette de prix",
    "filter.search": "Recherche",
    "filter.searchPlaceholder": "Rechercher des voitures...",
    "filter.seats": "Nombre de places",
    "filter.title": "Filtres",
    "footer.brands": "Marques",
    "footer.callUs": "Appelez-nous",
    "footer.categories": "Cat\u00e9gories",
    "footer.cities": "Lieux",
    "footer.downloadApp": "T\u00e9l\u00e9charger l'application",
    "footer.emailUs": "\u00c9crivez-nous",
    "footer.quickLinks": "Liens rapides",
    "footer.privacyPolicy": "Politique de confidentialité",
    "footer.visitUs": "Visitez notre bureau",
    "footer.visitors": "visiteurs",
    "footer.weAccept": "Nous acceptons",
    "form.email": "Adresse e-mail",
    "form.fullName": "Nom complet",
    "form.message": "Message",
    "form.name": "Nom",
    "form.password": "Mot de passe",
    "form.phone": "Num\u00e9ro de t\u00e9l\u00e9phone",
    "home.experienceLuxury": "Vivez le luxe \u00e0 chaque trajet",
    "home.featuredVehicles": "V\u00e9hicules vedettes",
    "home.premiumCarRental": "Location premium aux \u00c9mirats",
    "inquiry.error": "Impossible d'envoyer la demande. R\u00e9essayez.",
    "inquiry.success": "Demande envoy\u00e9e avec succ\u00e8s !",
    "inquiry.title": "Envoyez-nous un message",
    "listings.noResults": "Aucun v\u00e9hicule ne correspond \u00e0 vos filtres.",
    "listings.noResultsHint": "Essayez d'effacer quelques filtres.",
    "listings.pageTitle": "Louer une voiture aux \u00c9mirats",
    "listings.showing": "Affichage",
    "listings.subtitle": "D\u00e9couvrez le v\u00e9hicule id\u00e9al pour votre trajet",
    "listings.title": "Parcourez notre",
    "listings.titleHighlight": "collection",
    "listings.vehicles": "v\u00e9hicules",
    "messages.featuredComingSoon": "Les v\u00e9hicules vedettes arrivent bient\u00f4t",
    "notifications.comingSoon": "Notifications bient\u00f4t disponibles",
    "partners.all": "Tous",
    "partners.allPartners": "Tous les partenaires",
    "partners.becomePartner": "Devenir partenaire",
    "partners.contactUs": "Nous contacter",
    "partners.description": "Nous collaborons avec les meilleurs partenaires automobiles pour offrir une exp\u00e9rience de luxe in\u00e9gal\u00e9e.",
    "partners.featuredPartners": "Partenaires \u00e0 la une",
    "partners.featuredTitle": "Collaborations premium",
    "partners.learnMore": "En savoir plus",
    "partners.ourNetwork": "Notre r\u00e9seau",
    "partners.pageTitle": "Nos partenaires",
    "partners.subtitle": "R\u00e9seau de confiance",
    "partners.title": "Nos partenaires",
    "partners.visitWebsite": "Visiter le site",
    "pricing.allBrands": "Toutes les marques",
    "pricing.brandAZ": "Marque : A-Z",
    "pricing.brandZA": "Marque : Z-A",
    "pricing.carsFound": "voitures trouv\u00e9es",
    "pricing.category": "Cat\u00e9gorie",
    "pricing.daily": "Quotidien",
    "pricing.description": "Comparez les tarifs de toute notre flotte.",
    "pricing.monthly": "Mensuel",
    "pricing.noResults": "Aucune voiture trouv\u00e9e.",
    "pricing.pageTitle": "Tarifs de location",
    "pricing.priceHighest": "Prix : du plus \u00e9lev\u00e9 au plus bas",
    "pricing.priceLowest": "Prix : du plus bas au plus \u00e9lev\u00e9",
    "pricing.resetFilters": "R\u00e9initialiser les filtres",
    "pricing.sortBy": "Trier par",
    "pricing.subtitle": "Tarification transparente",
    "pricing.title": "Tarifs de location",
    "pricing.vehicle": "V\u00e9hicule",
    "pricing.weekly": "Hebdomadaire",
    "search.allCategories": "Toutes les cat\u00e9gories",
    "search.brand": "Marque",
    "search.brands": "Marques",
    "search.category": "Cat\u00e9gorie",
    "search.city": "Ville",
    "search.placeholder": "S\u00e9lectionner...",
    "search.popular": "Populaire",
    "search.recommended": "Recommand\u00e9",
    "search.selectBrand": "S\u00e9lectionner une marque",
    "search.selectCity": "S\u00e9lectionner une ville",
    "sections.categories": "Explorer nos cat\u00e9gories",
    "sections.cities": "Louer dans les villes des \u00c9mirats",
    "sections.featured": "V\u00e9hicules vedettes",
    "sections.faqTitle": "Questions fr\u00e9quentes",
    "sections.brands": "Explorer par marque",
    "splash.loading": "Pr\u00e9paration de votre exp\u00e9rience de luxe...",
    "splash.tagline": "Vivez le luxe"
  },
  "de": {
    "nav.home": "Startseite",
    "nav.cars": "Fahrzeuge",
    "nav.about": "\u00dcber uns",
    "nav.contact": "Kontakt",
    "nav.faq": "FAQ",
    "nav.categories": "Kategorien",
    "nav.cities": "St\u00e4dte",
    "nav.pricing": "Preise",
    "nav.partners": "Partner",
    "nav.favorites": "Favoriten",
    "nav.account": "Konto",
    "nav.browseCars": "Fahrzeuge ansehen",
    "auth.signIn": "Anmelden",
    "auth.signOut": "Abmelden",
    "btn.bookNow": "Jetzt buchen",
    "btn.browse": "Fahrzeuge ansehen",
    "btn.callNow": "Jetzt anrufen",
    "btn.contactUs": "Kontakt",
    "btn.search": "Suchen",
    "btn.viewAll": "Alle anzeigen",
    "common.address": "Adresse",
    "common.cancel": "Abbrechen",
    "common.carsAvailable": "Fahrzeuge verf\u00fcgbar",
    "common.currency": "W\u00e4hrung",
    "common.darkMode": "Dunkelmodus",
    "common.day": "Tag",
    "common.email": "E-Mail",
    "common.language": "Sprache",
    "common.lightMode": "Hellmodus",
    "common.loading": "Wird geladen...",
    "common.message": "Nachricht",
    "common.monthly": "Monatlich",
    "common.more": "Mehr",
    "common.name": "Name",
    "common.noResults": "Keine Ergebnisse",
    "common.perDay": "pro Tag",
    "common.perMonth": "pro Monat",
    "common.perWeek": "pro Woche",
    "common.phone": "Telefon",
    "common.search": "Suchen",
    "common.seats": "Sitze",
    "common.settings": "Einstellungen",
    "common.share": "Teilen",
    "common.theme": "Design",
    "common.total": "Gesamt",
    "common.vehicles": "Fahrzeuge",
    "common.vat": "MwSt.",
    "common.weekly": "W\u00f6chentlich",
    "common.workingHours": "Arbeitszeiten",
    "contact.description": "Haben Sie Fragen? Wir helfen Ihnen gern.",
    "contact.followUs": "Folgen Sie uns",
    "contact.formDescription": "F\u00fcllen Sie das Formular aus und wir melden uns schnellstm\u00f6glich.",
    "contact.getApp": "App herunterladen",
    "contact.info": "Kontaktinformationen",
    "contact.instantResponse": "Sofortige Antwort per WhatsApp",
    "contact.messageSent": "Nachricht erfolgreich gesendet!",
    "contact.pageTitle": "Kontakt | Autovermietung",
    "contact.quickContact": "Schnellkontakt",
    "contact.sendMessage": "Nachricht senden",
    "contact.subtitle": "Kontakt aufnehmen",
    "favorites.emptySubtitle": "Speichern Sie hier Ihre Lieblingsfahrzeuge",
    "favorites.emptyTitle": "Noch keine Favoriten",
    "favorites.loading": "Favoriten werden geladen...",
    "favorites.title": "Favoriten",
    "faq.heading": "H\u00e4ufig gestellte Fragen",
    "faq.noQuestions": "Keine Fragen gefunden.",
    "faq.searchPlaceholder": "Antworten suchen...",
    "faq.title": "FAQ",
    "filter.brand": "Marke",
    "filter.category": "Kategorie",
    "filter.city": "Stadt",
    "filter.clearAll": "Alle Filter l\u00f6schen",
    "filter.color": "Farbe",
    "filter.priceRange": "Preisspanne",
    "filter.search": "Suche",
    "filter.searchPlaceholder": "Fahrzeuge suchen...",
    "filter.seats": "Sitzanzahl",
    "filter.title": "Filter",
    "footer.brands": "Top-Marken",
    "footer.callUs": "Rufen Sie uns an",
    "footer.categories": "Kategorien",
    "footer.cities": "Standorte",
    "footer.downloadApp": "App herunterladen",
    "footer.emailUs": "E-Mail an uns",
    "footer.quickLinks": "Schnelllinks",
    "footer.privacyPolicy": "Datenschutzerklärung",
    "footer.visitUs": "Besuchen Sie unser B\u00fcro",
    "footer.visitors": "Besucher",
    "footer.weAccept": "Wir akzeptieren",
    "form.email": "E-Mail-Adresse",
    "form.fullName": "Vollst\u00e4ndiger Name",
    "form.message": "Nachricht",
    "form.name": "Name",
    "form.password": "Passwort",
    "form.phone": "Telefonnummer",
    "home.experienceLuxury": "Luxus auf jeder Fahrt erleben",
    "home.featuredVehicles": "Ausgew\u00e4hlte Fahrzeuge",
    "home.premiumCarRental": "Premium-Autovermietung in den VAE",
    "inquiry.error": "Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    "inquiry.success": "Anfrage erfolgreich gesendet!",
    "inquiry.title": "Senden Sie uns eine Nachricht",
    "listings.noResults": "Keine Fahrzeuge passen zu Ihren Filtern.",
    "listings.noResultsHint": "Versuchen Sie, einige Filter zu l\u00f6schen.",
    "listings.pageTitle": "Fahrzeuge in den VAE mieten",
    "listings.showing": "Angezeigt",
    "listings.subtitle": "Entdecken Sie das perfekte Fahrzeug f\u00fcr Ihre Reise",
    "listings.title": "Unsere",
    "listings.titleHighlight": "Kollektion",
    "listings.vehicles": "Fahrzeuge",
    "messages.featuredComingSoon": "Ausgew\u00e4hlte Fahrzeuge folgen bald",
    "notifications.comingSoon": "Benachrichtigungen bald verf\u00fcgbar",
    "partners.all": "Alle",
    "partners.allPartners": "Alle Partner",
    "partners.becomePartner": "Partner werden",
    "partners.contactUs": "Kontakt",
    "partners.description": "Wir arbeiten mit den besten Automobilpartnern zusammen, um ein unvergleichliches Luxuserlebnis zu bieten.",
    "partners.featuredPartners": "Ausgew\u00e4hlte Partner",
    "partners.featuredTitle": "Premium-Kooperationen",
    "partners.learnMore": "Mehr erfahren",
    "partners.ourNetwork": "Unser Netzwerk",
    "partners.pageTitle": "Unsere Partner",
    "partners.subtitle": "Vertrauensw\u00fcrdiges Netzwerk",
    "partners.title": "Unsere Partner",
    "partners.visitWebsite": "Website besuchen",
    "pricing.allBrands": "Alle Marken",
    "pricing.pageTitle": "Mietpreise",
    "pricing.title": "Mietpreise",
    "search.allCategories": "Alle Kategorien",
    "search.brand": "Marke",
    "search.category": "Kategorie",
    "search.city": "Stadt",
    "sections.categories": "Unsere Kategorien entdecken",
    "sections.cities": "Fahrzeuge in den St\u00e4dten der VAE mieten",
    "sections.featured": "Ausgew\u00e4hlte Fahrzeuge",
    "sections.faqTitle": "H\u00e4ufig gestellte Fragen",
    "sections.brands": "Nach Marke entdecken",
    "splash.loading": "Ihr Luxus-Erlebnis wird vorbereitet...",
    "splash.tagline": "Luxus erleben"
  },
  "ru": {
    "nav.home": "\u0413\u043b\u0430\u0432\u043d\u0430\u044f",
    "nav.cars": "\u0410\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0438",
    "nav.about": "\u041e \u043d\u0430\u0441",
    "nav.contact": "\u041a\u043e\u043d\u0442\u0430\u043a\u0442\u044b",
    "nav.faq": "FAQ",
    "nav.categories": "\u041a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0438",
    "nav.cities": "\u0413\u043e\u0440\u043e\u0434\u0430",
    "nav.pricing": "\u0426\u0435\u043d\u044b",
    "nav.partners": "\u041f\u0430\u0440\u0442\u043d\u0435\u0440\u044b",
    "nav.favorites": "\u0418\u0437\u0431\u0440\u0430\u043d\u043d\u043e\u0435",
    "nav.account": "\u0410\u043a\u043a\u0430\u0443\u043d\u0442",
    "nav.browseCars": "\u0421\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0430\u0432\u0442\u043e",
    "auth.signIn": "\u0412\u043e\u0439\u0442\u0438",
    "auth.signOut": "\u0412\u044b\u0439\u0442\u0438",
    "btn.bookNow": "\u0417\u0430\u0431\u0440\u043e\u043d\u0438\u0440\u043e\u0432\u0430\u0442\u044c",
    "btn.browse": "\u0421\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0430\u0432\u0442\u043e",
    "btn.callNow": "\u041f\u043e\u0437\u0432\u043e\u043d\u0438\u0442\u044c \u0441\u0435\u0439\u0447\u0430\u0441",
    "btn.contactUs": "\u0421\u0432\u044f\u0437\u0430\u0442\u044c\u0441\u044f \u0441 \u043d\u0430\u043c\u0438",
    "btn.search": "\u041f\u043e\u0438\u0441\u043a",
    "btn.viewAll": "\u0421\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0432\u0441\u0435",
    "common.address": "\u0410\u0434\u0440\u0435\u0441",
    "common.cancel": "\u041e\u0442\u043c\u0435\u043d\u0430",
    "common.carsAvailable": "\u0430\u0432\u0442\u043e \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u043e",
    "common.currency": "\u0412\u0430\u043b\u044e\u0442\u0430",
    "common.darkMode": "\u0422\u0435\u043c\u043d\u0430\u044f \u0442\u0435\u043c\u0430",
    "common.day": "\u0434\u0435\u043d\u044c",
    "common.email": "\u042d\u043b. \u043f\u043e\u0447\u0442\u0430",
    "common.language": "\u042f\u0437\u044b\u043a",
    "common.lightMode": "\u0421\u0432\u0435\u0442\u043b\u0430\u044f \u0442\u0435\u043c\u0430",
    "common.loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430...",
    "common.message": "\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435",
    "common.monthly": "\u0415\u0436\u0435\u043c\u0435\u0441\u044f\u0447\u043d\u043e",
    "common.more": "\u0415\u0449\u0435",
    "common.name": "\u0418\u043c\u044f",
    "common.noResults": "\u041d\u0438\u0447\u0435\u0433\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e",
    "common.perDay": "\u0432 \u0434\u0435\u043d\u044c",
    "common.perMonth": "\u0432 \u043c\u0435\u0441\u044f\u0446",
    "common.perWeek": "\u0432 \u043d\u0435\u0434\u0435\u043b\u044e",
    "common.phone": "\u0422\u0435\u043b\u0435\u0444\u043e\u043d",
    "common.search": "\u041f\u043e\u0438\u0441\u043a",
    "common.seats": "\u041c\u0435\u0441\u0442",
    "common.settings": "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438",
    "common.share": "\u041f\u043e\u0434\u0435\u043b\u0438\u0442\u044c\u0441\u044f",
    "common.theme": "\u0422\u0435\u043c\u0430",
    "common.total": "\u0418\u0442\u043e\u0433\u043e",
    "common.vehicles": "\u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0435\u0439",
    "common.vat": "\u041d\u0414\u0421",
    "common.weekly": "\u0415\u0436\u0435\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u043e",
    "common.workingHours": "\u0427\u0430\u0441\u044b \u0440\u0430\u0431\u043e\u0442\u044b",
    "contact.description": "\u0415\u0441\u0442\u044c \u0432\u043e\u043f\u0440\u043e\u0441\u044b? \u041c\u044b \u0433\u043e\u0442\u043e\u0432\u044b \u043f\u043e\u043c\u043e\u0447\u044c.",
    "contact.followUs": "\u041f\u043e\u0434\u043f\u0438\u0441\u044b\u0432\u0430\u0439\u0442\u0435\u0441\u044c",
    "contact.formDescription": "\u0417\u0430\u043f\u043e\u043b\u043d\u0438\u0442\u0435 \u0444\u043e\u0440\u043c\u0443 \u043d\u0438\u0436\u0435, \u0438 \u043c\u044b \u0441\u043a\u043e\u0440\u043e \u0441\u0432\u044f\u0436\u0435\u043c\u0441\u044f \u0441 \u0432\u0430\u043c\u0438.",
    "contact.getApp": "\u0421\u043a\u0430\u0447\u0430\u0442\u044c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435",
    "contact.info": "\u041a\u043e\u043d\u0442\u0430\u043a\u0442\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f",
    "contact.instantResponse": "\u041c\u0433\u043d\u043e\u0432\u0435\u043d\u043d\u044b\u0439 \u043e\u0442\u0432\u0435\u0442 \u0447\u0435\u0440\u0435\u0437 WhatsApp",
    "contact.messageSent": "\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e!",
    "contact.pageTitle": "\u0421\u0432\u044f\u0436\u0438\u0442\u0435\u0441\u044c \u0441 \u043d\u0430\u043c\u0438 | \u0410\u0440\u0435\u043d\u0434\u0430 \u0430\u0432\u0442\u043e",
    "contact.quickContact": "\u0411\u044b\u0441\u0442\u0440\u0430\u044f \u0441\u0432\u044f\u0437\u044c",
    "contact.sendMessage": "\u041e\u0442\u043f\u0440\u0430\u0432\u044c\u0442\u0435 \u043d\u0430\u043c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435",
    "contact.subtitle": "\u0421\u0432\u044f\u0436\u0438\u0442\u0435\u0441\u044c \u0441 \u043d\u0430\u043c\u0438",
    "favorites.emptySubtitle": "\u0421\u043e\u0445\u0440\u0430\u043d\u044f\u0439\u0442\u0435 \u043b\u044e\u0431\u0438\u043c\u044b\u0435 \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0438 \u0437\u0434\u0435\u0441\u044c",
    "favorites.emptyTitle": "\u041f\u043e\u043a\u0430 \u043d\u0435\u0442 \u0438\u0437\u0431\u0440\u0430\u043d\u043d\u043e\u0433\u043e",
    "favorites.loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0438\u0437\u0431\u0440\u0430\u043d\u043d\u043e\u0433\u043e...",
    "favorites.title": "\u0418\u0437\u0431\u0440\u0430\u043d\u043d\u043e\u0435",
    "faq.heading": "\u0427\u0430\u0441\u0442\u043e \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043c\u044b\u0435 \u0432\u043e\u043f\u0440\u043e\u0441\u044b",
    "faq.noQuestions": "\u0412\u043e\u043f\u0440\u043e\u0441\u044b \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u044b.",
    "faq.searchPlaceholder": "\u0418\u0441\u043a\u0430\u0442\u044c \u043e\u0442\u0432\u0435\u0442\u044b...",
    "faq.title": "FAQ",
    "filter.brand": "\u041c\u0430\u0440\u043a\u0430",
    "filter.category": "\u041a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u044f",
    "filter.city": "\u0413\u043e\u0440\u043e\u0434",
    "filter.clearAll": "\u0421\u0431\u0440\u043e\u0441\u0438\u0442\u044c \u0432\u0441\u0435 \u0444\u0438\u043b\u044c\u0442\u0440\u044b",
    "filter.color": "\u0426\u0432\u0435\u0442",
    "filter.priceRange": "\u0414\u0438\u0430\u043f\u0430\u0437\u043e\u043d \u0446\u0435\u043d",
    "filter.search": "\u041f\u043e\u0438\u0441\u043a",
    "filter.searchPlaceholder": "\u0418\u0441\u043a\u0430\u0442\u044c \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0438...",
    "filter.seats": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u043c\u0435\u0441\u0442",
    "filter.title": "\u0424\u0438\u043b\u044c\u0442\u0440\u044b",
    "footer.brands": "\u041f\u043e\u043f\u0443\u043b\u044f\u0440\u043d\u044b\u0435 \u0431\u0440\u0435\u043d\u0434\u044b",
    "footer.callUs": "\u041f\u043e\u0437\u0432\u043e\u043d\u0438\u0442\u0435 \u043d\u0430\u043c",
    "footer.categories": "\u041a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0438",
    "footer.cities": "\u041b\u043e\u043a\u0430\u0446\u0438\u0438",
    "footer.downloadApp": "\u0421\u043a\u0430\u0447\u0430\u0442\u044c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435",
    "footer.emailUs": "\u041d\u0430\u043f\u0438\u0448\u0438\u0442\u0435 \u043d\u0430\u043c",
    "footer.quickLinks": "\u0411\u044b\u0441\u0442\u0440\u044b\u0435 \u0441\u0441\u044b\u043b\u043a\u0438",
    "footer.privacyPolicy": "\u041f\u043e\u043b\u0438\u0442\u0438\u043a\u0430 \u043a\u043e\u043d\u0444\u0438\u0434\u0435\u043d\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0441\u0442\u0438",
    "footer.visitUs": "\u041f\u043e\u0441\u0435\u0442\u0438\u0442\u0435 \u043d\u0430\u0448 \u043e\u0444\u0438\u0441",
    "footer.visitors": "\u043f\u043e\u0441\u0435\u0442\u0438\u0442\u0435\u043b\u0435\u0439",
    "footer.weAccept": "\u041c\u044b \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u0435\u043c",
    "form.email": "\u0410\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b",
    "form.fullName": "\u041f\u043e\u043b\u043d\u043e\u0435 \u0438\u043c\u044f",
    "form.message": "\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435",
    "form.name": "\u0418\u043c\u044f",
    "form.password": "\u041f\u0430\u0440\u043e\u043b\u044c",
    "form.phone": "\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",
    "home.experienceLuxury": "\u0418\u0441\u043f\u044b\u0442\u0430\u0439\u0442\u0435 \u0440\u043e\u0441\u043a\u043e\u0448\u044c \u0432 \u043a\u0430\u0436\u0434\u043e\u0439 \u043f\u043e\u0435\u0437\u0434\u043a\u0435",
    "home.featuredVehicles": "\u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0435\u043c\u044b\u0435 \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0438",
    "home.premiumCarRental": "\u041f\u0440\u0435\u043c\u0438\u0430\u043b\u044c\u043d\u0430\u044f \u0430\u0440\u0435\u043d\u0434\u0430 \u0430\u0432\u0442\u043e \u0432 \u041e\u0410\u042d",
    "inquiry.error": "\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0437\u0430\u043f\u0440\u043e\u0441. \u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0441\u043d\u043e\u0432\u0430.",
    "inquiry.success": "\u0417\u0430\u043f\u0440\u043e\u0441 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d!",
    "inquiry.title": "\u041e\u0442\u043f\u0440\u0430\u0432\u044c\u0442\u0435 \u043d\u0430\u043c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435",
    "listings.noResults": "\u041d\u0435\u0442 \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0435\u0439, \u043f\u043e\u0434\u0445\u043e\u0434\u044f\u0449\u0438\u0445 \u043f\u043e\u0434 \u0432\u0430\u0448\u0438 \u0444\u0438\u043b\u044c\u0442\u0440\u044b.",
    "listings.noResultsHint": "\u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0441\u0431\u0440\u043e\u0441\u0438\u0442\u044c \u0447\u0430\u0441\u0442\u044c \u0444\u0438\u043b\u044c\u0442\u0440\u043e\u0432.",
    "listings.pageTitle": "\u0410\u0440\u0435\u043d\u0434\u0430 \u0430\u0432\u0442\u043e \u0432 \u041e\u0410\u042d",
    "listings.showing": "\u041f\u043e\u043a\u0430\u0437\u0430\u043d\u043e",
    "listings.subtitle": "\u041d\u0430\u0439\u0434\u0438\u0442\u0435 \u0438\u0434\u0435\u0430\u043b\u044c\u043d\u044b\u0439 \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u044c \u0434\u043b\u044f \u0432\u0430\u0448\u0435\u0439 \u043f\u043e\u0435\u0437\u0434\u043a\u0438",
    "listings.title": "\u041d\u0430\u0448\u0430",
    "listings.titleHighlight": "\u043a\u043e\u043b\u043b\u0435\u043a\u0446\u0438\u044f",
    "listings.vehicles": "\u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0435\u0439",
    "messages.featuredComingSoon": "\u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0435\u043c\u044b\u0435 \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0438\u043b\u0438 \u0441\u043a\u043e\u0440\u043e \u043f\u043e\u044f\u0432\u044f\u0442\u0441\u044f",
    "notifications.comingSoon": "\u0423\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u0438\u044f \u0441\u043a\u043e\u0440\u043e \u043f\u043e\u044f\u0432\u044f\u0442\u0441\u044f",
    "partners.all": "\u0412\u0441\u0435",
    "partners.allPartners": "\u0412\u0441\u0435 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u044b",
    "partners.becomePartner": "\u0421\u0442\u0430\u0442\u044c \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u043e\u043c",
    "partners.contactUs": "\u0421\u0432\u044f\u0437\u0430\u0442\u044c\u0441\u044f \u0441 \u043d\u0430\u043c\u0438",
    "partners.description": "\u041c\u044b \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u0447\u0430\u0435\u043c \u0441 \u043b\u0443\u0447\u0448\u0438\u043c\u0438 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u0430\u043c\u0438 \u043e\u0442\u0440\u0430\u0441\u043b\u0438, \u0447\u0442\u043e\u0431\u044b \u043f\u0440\u0435\u0434\u043b\u043e\u0436\u0438\u0442\u044c \u043f\u0440\u0435\u043c\u0438\u0430\u043b\u044c\u043d\u044b\u0439 \u0441\u0435\u0440\u0432\u0438\u0441.",
    "partners.featuredPartners": "\u0418\u0437\u0431\u0440\u0430\u043d\u043d\u044b\u0435 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u044b",
    "partners.featuredTitle": "\u041f\u0440\u0435\u043c\u0438\u0430\u043b\u044c\u043d\u044b\u0435 \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u0447\u0435\u0441\u0442\u0432\u0430",
    "partners.learnMore": "\u041f\u043e\u0434\u0440\u043e\u0431\u043d\u0435\u0435",
    "partners.ourNetwork": "\u041d\u0430\u0448\u0430 \u0441\u0435\u0442\u044c",
    "partners.pageTitle": "\u041d\u0430\u0448\u0438 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u044b",
    "partners.subtitle": "\u041d\u0430\u0434\u0435\u0436\u043d\u0430\u044f \u0441\u0435\u0442\u044c",
    "partners.title": "\u041d\u0430\u0448\u0438 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u044b",
    "partners.visitWebsite": "\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043d\u0430 \u0441\u0430\u0439\u0442",
    "pricing.allBrands": "\u0412\u0441\u0435 \u0431\u0440\u0435\u043d\u0434\u044b",
    "pricing.pageTitle": "\u0426\u0435\u043d\u044b \u043d\u0430 \u0430\u0440\u0435\u043d\u0434\u0443",
    "pricing.title": "\u0426\u0435\u043d\u044b \u043d\u0430 \u0430\u0440\u0435\u043d\u0434\u0443",
    "search.allCategories": "\u0412\u0441\u0435 \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0438",
    "search.brand": "\u041c\u0430\u0440\u043a\u0430",
    "search.category": "\u041a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u044f",
    "search.city": "\u0413\u043e\u0440\u043e\u0434",
    "sections.categories": "\u041d\u0430\u0448\u0438 \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0438",
    "sections.cities": "\u0410\u0440\u0435\u043d\u0434\u0430 \u0430\u0432\u0442\u043e \u0432 \u0433\u043e\u0440\u043e\u0434\u0430\u0445 \u041e\u0410\u042d",
    "sections.featured": "\u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0435\u043c\u044b\u0435 \u0430\u0432\u0442\u043e",
    "sections.faqTitle": "\u0427\u0430\u0441\u0442\u043e \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043c\u044b\u0435 \u0432\u043e\u043f\u0440\u043e\u0441\u044b",
    "sections.brands": "\u041f\u043e \u0431\u0440\u0435\u043d\u0434\u0443",
    "splash.loading": "\u041f\u043e\u0434\u0433\u043e\u0442\u0430\u0432\u043b\u0438\u0432\u0430\u0435\u043c \u0432\u0430\u0448 \u0440\u043e\u0441\u043a\u043e\u0448\u043d\u044b\u0439 \u043e\u043f\u044b\u0442...",
    "splash.tagline": "\u0418\u0441\u043f\u044b\u0442\u0430\u0439\u0442\u0435 \u0440\u043e\u0441\u043a\u043e\u0448\u044c"
  }
};

export const extraDefaultTranslations = {
  en: {
    "profile.signInTitle": "Please Sign In",
    "profile.signInDescription": "Sign in to view your profile",
    "profile.overview": "Overview",
    "profile.recentBookings": "Recent Bookings",
    "profile.recentActivity": "Recent Activity",
    "profile.pointsHistory": "Points History",
    "profile.tierBenefits": "Tier Benefits",
    "profile.totalSpent": "Total Spent",
    "profile.noBookings": "No bookings yet",
    "profile.noActivity": "No activity yet",
    "profile.noHistory": "No history yet",
    "profile.member": "Member",
    "profile.saveCars": "Save cars you love for quick access!",
    "profile.startExploring": "Start exploring our premium cars!",
    "profile.browseCollection": "Discover the latest arrivals, exclusive deals, and premium brands curated for your next drive.",
    "common.referenceShort": "Ref",
    "common.pickup": "Pickup",
    "common.return": "Return",
    "common.discount": "Discount",
    "compare.add": "Add to comparison",
    "compare.remove": "Remove from comparison",
    "compare.trayTitle": "Compare Cars",
    "compare.selected": "selected",
    "compare.clear": "Clear comparison",
    "compare.open": "Open comparison",
    "compare.addMore": "Add one more car",
    "compare.pricePerDay": "Price / Day",
    "compare.category": "Category",
    "compare.city": "City",
    "compare.year": "Year",
    "compare.seats": "Seats",
    "compare.transmission": "Transmission",
    "compare.fuelType": "Fuel Type",
    "compare.engine": "Engine",
    "compare.power": "Power",
    "compare.supplier": "Supplier",
    "compare.pageTitle": "Compare Cars",
    "compare.pageDescription": "Compare your selected cars side by side before you contact Velaris Royal.",
    "compare.heroEyebrow": "Side by side",
    "compare.heading": "Compare Your Selected Cars",
    "compare.subheading": "Review pricing, specs, and supplier details in one focused view before you make contact.",
    "compare.browseMore": "Browse more cars",
    "compare.emptyTitle": "No cars selected yet",
    "compare.needMoreTitle": "Add one more car to compare",
    "compare.emptyDescription": "Use Compare on any car card or detail page to build a side-by-side shortlist.",
    "compare.needMoreDescription": "Comparison becomes available once you have at least two cars in your tray.",
    "compare.unknownYear": "Year pending",
    "compare.specification": "Specification",
    "compare.removedToast": "Car removed from comparison.",
    "compare.limitReached": "You can compare up to 4 cars at once.",
    "compare.alreadyAdded": "This car is already in your comparison tray.",
    "compare.firstAdded": "Car added. Pick one more to open comparison.",
    "compare.addedToast": "Car added to comparison.",
    "compare.title": "Compare Cars",
    "compare.helper": "Add up to 4 cars and review pricing, specs, and supplier details side by side.",
    "compare.removeCurrent": "Remove current car",
    "compare.addCurrent": "Add current car",
    "contact.whatsappPrefill": "Hi! I'd like to inquire about your car rental services.",
    "contact.whatsapp": "WhatsApp",
    "contact.phone": "Phone",
    "contact.email": "Email",
    "contact.callSupport": "Speak directly with our rental advisors",
    "contact.emailReply": "Best for detailed requests and partnership inquiries",
    "contact.address": "Address",
    "contact.hours": "Working Hours",
    "contact.altMethods": "Use the contact form for detailed requests, or jump straight to WhatsApp, phone, or email if you need a faster reply.",
    "contact.heading": "Talk to Velaris Royal in the way that suits you best.",
    "contact.pageDescription": "Contact Velaris Royal Car Rental for luxury car rentals in Dubai and across the UAE. Reach us by phone, WhatsApp, email, or the contact form.",
    "contact.formEyebrow": "Send a Message",
    "contact.formTrust": "We typically reply within a few business hours. For urgent requests, WhatsApp is the fastest channel.",
    "contact.sending": "Sending...",
    "contact.mapEyebrow": "Visit Us",
    "contact.mapTitle": "Drop by our Dubai base",
    "contact.submitError": "We couldn't send your message. Please try again.",
    "auth.emailAlreadyInUse": "This email is already registered. Please sign in.",
    "auth.emailNotVerified": "Please verify your email before signing in. We sent a new verification email. Check your inbox and spam/junk folder.",
    "auth.firebaseUnavailable": "Firebase Auth is not configured yet.",
    "auth.resetEmailInstructions": "Open the email from Firebase to choose a new password, then come back and sign in. If you do not see it, check your spam/junk folder.",
    "auth.resetEmailInstructionsShort": "Check your email for password reset instructions, including spam/junk.",
    "auth.resetLinkSent": "Password reset link sent. Check your inbox and spam/junk folder.",
    "auth.resettingPasswordFor": "Resetting password for",
    "auth.verifyEmailSent": "Verification email sent. Please check your inbox and spam/junk folder, verify your email, then sign in.",
    "form.subject": "Subject",
    "form.title": "Title",
    "form.note": "Note",
    "form.messagePlaceholder": "Tell us how we can help you...",
    "form.generalInquiry": "General Inquiry",
    "form.bookingRequest": "Booking Request",
    "form.customerSupport": "Customer Support",
    "form.partnership": "Partnership",
    "form.feedback": "Feedback",
    "form.selectSubject": "Select a subject"
  },
  ar: {
    "profile.signInTitle": "يرجى تسجيل الدخول",
    "profile.signInDescription": "سجل الدخول لعرض ملفك الشخصي",
    "profile.overview": "نظرة عامة",
    "profile.recentBookings": "أحدث الحجوزات",
    "profile.recentActivity": "آخر النشاطات",
    "profile.pointsHistory": "سجل النقاط",
    "profile.tierBenefits": "مزايا المستوى",
    "profile.totalSpent": "إجمالي الإنفاق",
    "profile.noBookings": "لا توجد حجوزات بعد",
    "profile.noActivity": "لا يوجد نشاط بعد",
    "profile.noHistory": "لا يوجد سجل بعد",
    "profile.member": "عضو",
    "profile.saveCars": "احفظ السيارات التي تحبها للوصول السريع!",
    "profile.startExploring": "ابدأ بتصفح سياراتنا المميزة!",
    "profile.browseCollection": "اكتشف أحدث السيارات والعروض الحصرية وأفضل العلامات لرحلتك القادمة.",
    "common.referenceShort": "المرجع",
    "common.pickup": "الاستلام",
    "common.return": "التسليم",
    "common.discount": "الخصم",
    "compare.add": "أضف للمقارنة",
    "compare.remove": "إزالة من المقارنة",
    "compare.trayTitle": "قارن السيارات",
    "compare.selected": "محددة",
    "compare.clear": "مسح المقارنة",
    "compare.open": "فتح المقارنة",
    "compare.addMore": "أضف سيارة أخرى",
    "compare.pricePerDay": "السعر / اليوم",
    "compare.category": "الفئة",
    "compare.city": "المدينة",
    "compare.year": "السنة",
    "compare.seats": "المقاعد",
    "compare.transmission": "ناقل الحركة",
    "compare.fuelType": "نوع الوقود",
    "compare.engine": "المحرك",
    "compare.power": "القوة",
    "compare.supplier": "المورّد",
    "compare.pageTitle": "مقارنة السيارات",
    "compare.pageDescription": "قارن السيارات التي اخترتها جنبًا إلى جنب قبل التواصل مع Velaris Royal.",
    "compare.heroEyebrow": "جنبًا إلى جنب",
    "compare.heading": "قارن السيارات التي اخترتها",
    "compare.subheading": "راجع الأسعار والمواصفات وبيانات المورّد في عرض واحد واضح قبل التواصل.",
    "compare.browseMore": "تصفح المزيد من السيارات",
    "compare.emptyTitle": "لا توجد سيارات محددة بعد",
    "compare.needMoreTitle": "أضف سيارة أخرى للمقارنة",
    "compare.emptyDescription": "استخدم زر المقارنة في بطاقة السيارة أو صفحة التفاصيل لبناء قائمة مختصرة جنبًا إلى جنب.",
    "compare.needMoreDescription": "تتوفر المقارنة عند إضافة سيارتين على الأقل إلى القائمة.",
    "compare.unknownYear": "السنة غير متاحة",
    "compare.specification": "المواصفة",
    "compare.removedToast": "تمت إزالة السيارة من المقارنة.",
    "compare.limitReached": "يمكنك مقارنة حتى 4 سيارات فقط.",
    "compare.alreadyAdded": "هذه السيارة موجودة بالفعل في قائمة المقارنة.",
    "compare.firstAdded": "تمت إضافة السيارة. اختر سيارة أخرى لفتح المقارنة.",
    "compare.addedToast": "تمت إضافة السيارة إلى المقارنة.",
    "compare.title": "قارن السيارات",
    "compare.helper": "أضف حتى 4 سيارات وراجع الأسعار والمواصفات وبيانات المورّد جنبًا إلى جنب.",
    "compare.removeCurrent": "إزالة السيارة الحالية",
    "compare.addCurrent": "إضافة السيارة الحالية",
    "contact.whatsappPrefill": "مرحبًا، أود الاستفسار عن خدمات تأجير السيارات لديكم.",
    "contact.whatsapp": "واتساب",
    "contact.phone": "الهاتف",
    "contact.email": "البريد الإلكتروني",
    "contact.callSupport": "تحدث مباشرة مع مستشاري التأجير",
    "contact.emailReply": "الأفضل للطلبات التفصيلية واستفسارات الشراكات",
    "contact.address": "العنوان",
    "contact.hours": "ساعات العمل",
    "contact.altMethods": "استخدم نموذج التواصل للطلبات التفصيلية، أو انتقل مباشرة إلى واتساب أو الهاتف أو البريد الإلكتروني إذا كنت تحتاج ردًا أسرع.",
    "contact.heading": "تحدث مع Velaris Royal بالطريقة التي تناسبك.",
    "contact.pageDescription": "تواصل مع Velaris Royal لتأجير السيارات الفاخرة في دبي وجميع أنحاء الإمارات عبر الهاتف أو واتساب أو البريد الإلكتروني أو نموذج التواصل.",
    "contact.formEyebrow": "أرسل رسالة",
    "contact.formTrust": "نرد عادة خلال بضع ساعات عمل. للطلبات العاجلة، واتساب هو الأسرع.",
    "contact.sending": "جارٍ الإرسال...",
    "contact.mapEyebrow": "زرنا",
    "contact.mapTitle": "زر مقرنا في دبي",
    "contact.submitError": "تعذر إرسال رسالتك. يرجى المحاولة مرة أخرى.",
    "form.subject": "الموضوع",
    "form.title": "العنوان",
    "form.note": "الملاحظة",
    "form.messagePlaceholder": "أخبرنا كيف يمكننا مساعدتك...",
    "form.generalInquiry": "استفسار عام",
    "form.bookingRequest": "طلب حجز",
    "form.customerSupport": "دعم العملاء",
    "form.partnership": "شراكة",
    "form.feedback": "ملاحظات",
    "form.selectSubject": "اختر موضوعًا"
  },
  fr: {
    "profile.signInTitle": "Veuillez vous connecter",
    "profile.signInDescription": "Connectez-vous pour voir votre profil",
    "profile.overview": "Aperçu",
    "profile.recentBookings": "Réservations récentes",
    "profile.recentActivity": "Activité récente",
    "profile.pointsHistory": "Historique des points",
    "profile.tierBenefits": "Avantages du niveau",
    "profile.totalSpent": "Dépenses totales",
    "profile.noBookings": "Aucune réservation pour le moment",
    "profile.noActivity": "Aucune activité pour le moment",
    "profile.noHistory": "Aucun historique pour le moment",
    "profile.member": "Membre",
    "profile.saveCars": "Enregistrez vos voitures préférées pour y accéder rapidement !",
    "profile.startExploring": "Commencez à explorer notre collection premium !",
    "profile.browseCollection": "Découvrez les dernières arrivées, les offres exclusives et les marques premium pour votre prochain trajet.",
    "common.referenceShort": "Réf.",
    "common.pickup": "Départ",
    "common.return": "Retour",
    "common.discount": "Remise",
    "compare.add": "Ajouter à la comparaison",
    "compare.remove": "Retirer de la comparaison",
    "compare.trayTitle": "Comparer les voitures",
    "compare.selected": "sélectionnées",
    "compare.clear": "Effacer la comparaison",
    "compare.open": "Ouvrir la comparaison",
    "compare.addMore": "Ajoutez une autre voiture",
    "compare.pricePerDay": "Prix / jour",
    "compare.category": "Catégorie",
    "compare.city": "Ville",
    "compare.year": "Année",
    "compare.seats": "Places",
    "compare.transmission": "Transmission",
    "compare.fuelType": "Type de carburant",
    "compare.engine": "Moteur",
    "compare.power": "Puissance",
    "compare.supplier": "Fournisseur",
    "compare.pageTitle": "Comparer les voitures",
    "compare.pageDescription": "Comparez côte à côte les voitures sélectionnées avant de contacter Velaris Royal.",
    "compare.heroEyebrow": "Côte à côte",
    "compare.heading": "Comparez les voitures sélectionnées",
    "compare.subheading": "Passez en revue tarifs, spécifications et détails du fournisseur dans une seule vue claire avant de nous contacter.",
    "compare.browseMore": "Voir plus de voitures",
    "compare.emptyTitle": "Aucune voiture sélectionnée",
    "compare.needMoreTitle": "Ajoutez une autre voiture pour comparer",
    "compare.emptyDescription": "Utilisez Comparer sur une fiche voiture ou une page détail pour créer une présélection côte à côte.",
    "compare.needMoreDescription": "La comparaison est disponible dès que vous avez au moins deux voitures dans votre sélection.",
    "compare.unknownYear": "Année en attente",
    "compare.specification": "Caractéristique",
    "compare.removedToast": "Voiture retirée de la comparaison.",
    "compare.limitReached": "Vous pouvez comparer jusqu’à 4 voitures.",
    "compare.alreadyAdded": "Cette voiture est déjà dans votre sélection de comparaison.",
    "compare.firstAdded": "Voiture ajoutée. Choisissez-en une autre pour ouvrir la comparaison.",
    "compare.addedToast": "Voiture ajoutée à la comparaison.",
    "compare.title": "Comparer les voitures",
    "compare.helper": "Ajoutez jusqu’à 4 voitures et comparez tarifs, caractéristiques et informations fournisseur côte à côte.",
    "compare.removeCurrent": "Retirer la voiture actuelle",
    "compare.addCurrent": "Ajouter la voiture actuelle",
    "contact.whatsappPrefill": "Bonjour, je souhaite me renseigner sur vos services de location de voitures.",
    "contact.whatsapp": "WhatsApp",
    "contact.phone": "Téléphone",
    "contact.email": "E-mail",
    "contact.callSupport": "Parlez directement avec nos conseillers location",
    "contact.emailReply": "Idéal pour les demandes détaillées et les partenariats",
    "contact.address": "Adresse",
    "contact.hours": "Horaires",
    "contact.altMethods": "Utilisez le formulaire pour les demandes détaillées, ou passez directement par WhatsApp, téléphone ou e-mail pour une réponse plus rapide.",
    "contact.heading": "Contactez Velaris Royal de la manière qui vous convient.",
    "contact.pageDescription": "Contactez Velaris Royal Car Rental pour des locations de voitures de luxe à Dubaï et aux Émirats. Joignez-nous par téléphone, WhatsApp, e-mail ou via le formulaire.",
    "contact.formEyebrow": "Envoyer un message",
    "contact.formTrust": "Nous répondons généralement en quelques heures ouvrées. Pour les demandes urgentes, WhatsApp reste le canal le plus rapide.",
    "contact.sending": "Envoi...",
    "contact.mapEyebrow": "Nous rendre visite",
    "contact.mapTitle": "Passez à notre adresse de Dubaï",
    "contact.submitError": "Nous n'avons pas pu envoyer votre message. Veuillez réessayer.",
    "form.subject": "Objet",
    "form.title": "Titre",
    "form.note": "Note",
    "form.messagePlaceholder": "Expliquez-nous comment nous pouvons vous aider...",
    "form.generalInquiry": "Demande générale",
    "form.bookingRequest": "Demande de réservation",
    "form.customerSupport": "Assistance client",
    "form.partnership": "Partenariat",
    "form.feedback": "Retour",
    "form.selectSubject": "Sélectionnez un objet"
  },
  de: {
    "profile.signInTitle": "Bitte anmelden",
    "profile.signInDescription": "Melden Sie sich an, um Ihr Profil zu sehen",
    "profile.overview": "Übersicht",
    "profile.recentBookings": "Letzte Buchungen",
    "profile.recentActivity": "Letzte Aktivitäten",
    "profile.pointsHistory": "Punkteverlauf",
    "profile.tierBenefits": "Level-Vorteile",
    "profile.totalSpent": "Gesamtausgaben",
    "profile.noBookings": "Noch keine Buchungen",
    "profile.noActivity": "Noch keine Aktivitäten",
    "profile.noHistory": "Noch kein Verlauf",
    "profile.member": "Mitglied",
    "profile.saveCars": "Speichern Sie Ihre Lieblingsfahrzeuge für den schnellen Zugriff!",
    "profile.startExploring": "Entdecken Sie jetzt unsere Premium-Fahrzeuge!",
    "profile.browseCollection": "Entdecken Sie die neuesten Fahrzeuge, exklusive Angebote und Premium-Marken für Ihre nächste Fahrt.",
    "common.referenceShort": "Ref.",
    "common.pickup": "Abholung",
    "common.return": "Rückgabe",
    "common.discount": "Rabatt",
    "compare.add": "Zur Vergleichsliste hinzufügen",
    "compare.remove": "Aus dem Vergleich entfernen",
    "compare.trayTitle": "Autos vergleichen",
    "compare.selected": "ausgewählt",
    "compare.clear": "Vergleich leeren",
    "compare.open": "Vergleich öffnen",
    "compare.addMore": "Ein weiteres Auto hinzufügen",
    "compare.pricePerDay": "Preis / Tag",
    "compare.category": "Kategorie",
    "compare.city": "Stadt",
    "compare.year": "Jahr",
    "compare.seats": "Sitze",
    "compare.transmission": "Getriebe",
    "compare.fuelType": "Kraftstoffart",
    "compare.engine": "Motor",
    "compare.power": "Leistung",
    "compare.supplier": "Anbieter",
    "compare.pageTitle": "Autos vergleichen",
    "compare.pageDescription": "Vergleichen Sie Ihre ausgewählten Autos nebeneinander, bevor Sie Velaris Royal kontaktieren.",
    "compare.heroEyebrow": "Seite an Seite",
    "compare.heading": "Vergleichen Sie Ihre ausgewählten Autos",
    "compare.subheading": "Prüfen Sie Preise, Daten und Anbieterdetails in einer klaren Übersicht, bevor Sie Kontakt aufnehmen.",
    "compare.browseMore": "Weitere Autos ansehen",
    "compare.emptyTitle": "Noch keine Autos ausgewählt",
    "compare.needMoreTitle": "Fügen Sie ein weiteres Auto hinzu",
    "compare.emptyDescription": "Nutzen Sie Vergleichen auf einer Fahrzeugkarte oder Detailseite, um eine direkte Auswahl aufzubauen.",
    "compare.needMoreDescription": "Der Vergleich ist verfügbar, sobald mindestens zwei Autos ausgewählt sind.",
    "compare.unknownYear": "Jahr ausstehend",
    "compare.specification": "Merkmal",
    "compare.removedToast": "Auto aus dem Vergleich entfernt.",
    "compare.limitReached": "Sie können bis zu 4 Autos vergleichen.",
    "compare.alreadyAdded": "Dieses Auto befindet sich bereits im Vergleich.",
    "compare.firstAdded": "Auto hinzugefügt. Wählen Sie ein weiteres aus, um den Vergleich zu öffnen.",
    "compare.addedToast": "Auto zum Vergleich hinzugefügt.",
    "compare.title": "Autos vergleichen",
    "compare.helper": "Fügen Sie bis zu 4 Autos hinzu und vergleichen Sie Preise, Daten und Anbieterdetails nebeneinander.",
    "compare.removeCurrent": "Aktuelles Auto entfernen",
    "compare.addCurrent": "Aktuelles Auto hinzufügen",
    "contact.whatsappPrefill": "Hallo, ich möchte mich über Ihre Autovermietung informieren.",
    "contact.whatsapp": "WhatsApp",
    "contact.phone": "Telefon",
    "contact.email": "E-Mail",
    "contact.callSupport": "Sprechen Sie direkt mit unseren Mietberatern",
    "contact.emailReply": "Ideal für detaillierte Anfragen und Partnerschaften",
    "contact.address": "Adresse",
    "contact.hours": "Öffnungszeiten",
    "contact.altMethods": "Nutzen Sie das Formular für detaillierte Anfragen oder wechseln Sie direkt zu WhatsApp, Telefon oder E-Mail, wenn Sie schneller eine Antwort benötigen.",
    "contact.heading": "Kontaktieren Sie Velaris Royal auf die Art, die Ihnen am besten passt.",
    "contact.pageDescription": "Kontaktieren Sie Velaris Royal Car Rental für Luxusautovermietung in Dubai und den VAE per Telefon, WhatsApp, E-Mail oder Kontaktformular.",
    "contact.formEyebrow": "Nachricht senden",
    "contact.formTrust": "Wir antworten in der Regel innerhalb weniger Geschäftsstunden. Für dringende Anfragen ist WhatsApp der schnellste Kanal.",
    "contact.sending": "Wird gesendet...",
    "contact.mapEyebrow": "Besuchen Sie uns",
    "contact.mapTitle": "Besuchen Sie uns in Dubai",
    "contact.submitError": "Ihre Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "form.subject": "Betreff",
    "form.title": "Titel",
    "form.note": "Notiz",
    "form.messagePlaceholder": "Sagen Sie uns, wie wir Ihnen helfen können...",
    "form.generalInquiry": "Allgemeine Anfrage",
    "form.bookingRequest": "Buchungsanfrage",
    "form.customerSupport": "Kundensupport",
    "form.partnership": "Partnerschaft",
    "form.feedback": "Feedback",
    "form.selectSubject": "Betreff auswählen"
  },
  ru: {
    "profile.signInTitle": "Пожалуйста, войдите",
    "profile.signInDescription": "Войдите, чтобы открыть профиль",
    "profile.overview": "Обзор",
    "profile.recentBookings": "Недавние бронирования",
    "profile.recentActivity": "Недавняя активность",
    "profile.pointsHistory": "История баллов",
    "profile.tierBenefits": "Преимущества уровня",
    "profile.totalSpent": "Общие расходы",
    "profile.noBookings": "Пока нет бронирований",
    "profile.noActivity": "Пока нет активности",
    "profile.noHistory": "История пока пуста",
    "profile.member": "Участник",
    "profile.saveCars": "Сохраняйте понравившиеся автомобили для быстрого доступа!",
    "profile.startExploring": "Начните знакомство с нашей премиальной коллекцией!",
    "profile.browseCollection": "Откройте для себя новые поступления, эксклюзивные предложения и премиальные бренды для вашей следующей поездки.",
    "common.referenceShort": "№",
    "common.pickup": "Получение",
    "common.return": "Возврат",
    "common.discount": "Скидка",
    "compare.add": "Добавить к сравнению",
    "compare.remove": "Убрать из сравнения",
    "compare.trayTitle": "Сравнить автомобили",
    "compare.selected": "выбрано",
    "compare.clear": "Очистить сравнение",
    "compare.open": "Открыть сравнение",
    "compare.addMore": "Добавьте еще один автомобиль",
    "compare.pricePerDay": "Цена / день",
    "compare.category": "Категория",
    "compare.city": "Город",
    "compare.year": "Год",
    "compare.seats": "Места",
    "compare.transmission": "Трансмиссия",
    "compare.fuelType": "Тип топлива",
    "compare.engine": "Двигатель",
    "compare.power": "Мощность",
    "compare.supplier": "Поставщик",
    "compare.pageTitle": "Сравнение автомобилей",
    "compare.pageDescription": "Сравните выбранные автомобили бок о бок перед тем, как связаться с Velaris Royal.",
    "compare.heroEyebrow": "Бок о бок",
    "compare.heading": "Сравните выбранные автомобили",
    "compare.subheading": "Посмотрите цены, характеристики и данные поставщика в одном удобном виде перед обращением.",
    "compare.browseMore": "Посмотреть больше автомобилей",
    "compare.emptyTitle": "Автомобили пока не выбраны",
    "compare.needMoreTitle": "Добавьте еще один автомобиль для сравнения",
    "compare.emptyDescription": "Используйте Compare на карточке автомобиля или странице деталей, чтобы собрать список для сравнения.",
    "compare.needMoreDescription": "Сравнение доступно, когда в списке есть минимум два автомобиля.",
    "compare.unknownYear": "Год уточняется",
    "compare.specification": "Характеристика",
    "compare.removedToast": "Автомобиль удален из сравнения.",
    "compare.limitReached": "Можно сравнивать не более 4 автомобилей.",
    "compare.alreadyAdded": "Этот автомобиль уже есть в списке сравнения.",
    "compare.firstAdded": "Автомобиль добавлен. Выберите еще один, чтобы открыть сравнение.",
    "compare.addedToast": "Автомобиль добавлен к сравнению.",
    "compare.title": "Сравнить автомобили",
    "compare.helper": "Добавьте до 4 автомобилей и сравните цены, характеристики и данные поставщика бок о бок.",
    "compare.removeCurrent": "Убрать текущий автомобиль",
    "compare.addCurrent": "Добавить текущий автомобиль",
    "contact.whatsappPrefill": "Здравствуйте! Я хотел(а) бы узнать подробнее о ваших услугах аренды авто.",
    "contact.whatsapp": "WhatsApp",
    "contact.phone": "Телефон",
    "contact.email": "Email",
    "contact.callSupport": "Свяжитесь напрямую с нашими консультантами по аренде",
    "contact.emailReply": "Подходит для подробных запросов и партнерских обращений",
    "contact.address": "Адрес",
    "contact.hours": "Часы работы",
    "contact.altMethods": "Используйте форму для подробных запросов или сразу переходите в WhatsApp, звонок или e-mail, если нужен более быстрый ответ.",
    "contact.heading": "Свяжитесь с Velaris Royal удобным для вас способом.",
    "contact.pageDescription": "Свяжитесь с Velaris Royal Car Rental по вопросам аренды премиальных авто в Дубае и ОАЭ по телефону, через WhatsApp, e-mail или форму обратной связи.",
    "contact.formEyebrow": "Отправить сообщение",
    "contact.formTrust": "Обычно мы отвечаем в течение нескольких рабочих часов. Для срочных запросов быстрее всего WhatsApp.",
    "contact.sending": "Отправка...",
    "contact.mapEyebrow": "Посетите нас",
    "contact.mapTitle": "Заезжайте к нам в Дубае",
    "contact.submitError": "Не удалось отправить сообщение. Попробуйте еще раз.",
    "form.subject": "Тема",
    "form.title": "Заголовок",
    "form.note": "Примечание",
    "form.messagePlaceholder": "Расскажите, чем мы можем помочь...",
    "form.generalInquiry": "Общий запрос",
    "form.bookingRequest": "Запрос на бронирование",
    "form.customerSupport": "Поддержка клиентов",
    "form.partnership": "Партнерство",
    "form.feedback": "Обратная связь",
    "form.selectSubject": "Выберите тему"
  }
};

export const normalizeLanguageCode = (langCode = "en") => {
  const shortCode = (langCode || "en").split("_")[0].toLowerCase();
  return supportedLanguageCodes.includes(shortCode) ? shortCode : "en";
};

export const getDefaultTranslations = (langCode = "en") => {
  const shortCode = normalizeLanguageCode(langCode);
  return {
    ...defaultTranslations.en,
    ...(extraDefaultTranslations.en || {}),
    ...(supplementalExtraDefaultTranslations.en || {}),
    ...(l10nAuditTranslations.en || {}),
    ...(defaultTranslations[shortCode] || {}),
    ...(extraDefaultTranslations[shortCode] || {}),
    ...(supplementalExtraDefaultTranslations[shortCode] || {}),
    ...(l10nAuditTranslations[shortCode] || {}),
  };
};
